<ng-container *transloco="let t; prefix: 'dashboard_settings'">
  <div
    class="hidden font-semibold text-xs text-neutral-500 md:flex gap-x-1 items-center"
    *transloco="let t; prefix: 'nav'"
  >
    <button
      routerLink="/home"
      class="btn btn-link p-0 no-underline text-neutral-500"
    >
      <span>{{ t("home") }}</span>
    </button>
    <i class="fa-solid fa-chevron-right"></i>
    <button
      routerLink="/home/transactions"
      class="btn btn-link p-0 no-underline text-neutral-500"
    >
      <span>{{ t("settings") }}</span>
    </button>
  </div>

  <h1 class="font-extrabold text-4xl">{{ t("title") }}</h1>
  <p>{{ t("subtitle") }}</p>

  <div class="flex flex-col gap-y-2 mt-5">
    <!-- <div class="collapse collapse-arrow bg-white dark:bg-base-100">
      <input type="checkbox" name="services" checked />
      <div class="collapse-title font-normal">Account</div>
      <div class="collapse-content bg-base-200">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2 my-4">
          <button
            class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex justify-between gap-2 px-3 p-2 rounded-box hover:md:bg-primary hover:md:text-white"
          >
            <div class="flex items-center gap-2">
              <i class="fa-light fa-circle-user text-2xl"></i>
              <span class="text-sm">User Profile</span>
            </div>
            <i class="fa-light fa-chevron-right text-lg"></i>
          </button>
          <button
            class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex justify-between gap-2 px-3 p-2 rounded-box hover:md:bg-primary hover:md:text-white"
          >
            <div class="flex items-center gap-2">
              <i class="fa-light fa-circle-user text-2xl"></i>
              <span class="text-sm">Preferences</span>
            </div>
            <i class="fa-light fa-chevron-right text-lg"></i>
          </button>
        </div>
      </div>
    </div> -->
    <div class="collapse collapse-arrow bg-white dark:bg-base-100">
      <input type="checkbox" name="services" checked />
      <div class="collapse-title font-normal">{{ t("business") }}</div>
      <div class="collapse-content bg-base-200">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2 my-4">
          <label
            for="business-profile"
            class="drawer-button size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex justify-between gap-2 px-3 p-2 rounded-box hover:md:bg-primary hover:md:text-white"
            (click)="loadBusinessData()"
          >
            <div class="flex items-center gap-2">
              <i class="fa-light fa-shop text-xl"></i>
              <span class="text-sm">{{ t("business_profile") }}</span>
            </div>
            <i class="fa-light fa-chevron-right text-lg"></i>
          </label>

          <button
            class="size-full btn bg-white dark:bg-base-100 dark:shadow-base-300 dark:shadow-md shadow-lg border-1 dark:border-base-100 border-base-200 flex justify-between gap-2 px-3 p-2 rounded-box hover:md:bg-primary hover:md:text-white"
            (click)="managePaymentAccounts()"
          >
            <div class="flex items-center gap-2">
              <i class="fa-light fa-credit-card text-xl"></i>
              <span class="text-sm">{{ t("payment_methods") }}</span>
            </div>
            <i class="fa-light fa-chevron-right text-lg"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="flex mt-5 w-full">
    <div
      role="tablist"
      class="tabs tabs-boxed flex shadow font-semibold bg-white dark:bg-base-100 rounded-box p-2 w-full"
    >
      <a role="tab" class="tab flex-1 rounded-box tab-active">Account</a>
      <a role="tab" class="tab flex-1 rounded-box">Business Profile</a>
      <a role="tab" class="tab flex-1 rounded-box">Payment Method</a>
    </div>
  </div> -->

  <!-- <div class="grid grid-cols-3 gap-2 md:gap-6 mb-4">
    <div class="stats shadow bg-white dark:bg-base-100 rounded-box">
      <div class="stat p-2 md:p-4">
        <div class="stat-figure dark:text-slate-300 text-primary hidden md:flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
            class="w-8 h-8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
            ></path>
          </svg>
        </div>
        <div class="stat-title text-xs md:text-base dark:text-slate-300 mb-1">
          Total
        </div>
        <div
          class="stat-value text-2xl md:text-4xl leading-none dark:text-slate-300 text-primary"
        >
          58
        </div>
        <div class="stat-desc font-bold text-green-700 dark:text-green-300">
            +288 this Month
          </div>
      </div>
    </div>
    <div class="stats shadow bg-white dark:bg-base-100 rounded-box">
      <div class="stat p-2 md:p-4">
        <div class="stat-figure dark:text-slate-300 text-primary hidden md:flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
            class="w-8 h-8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"
            ></path>
          </svg>
        </div>
        <div class="stat-title text-xs md:text-base dark:text-slate-300 mb-1">
          Successful
        </div>
        <div
          class="stat-value text-2xl md:text-4xl leading-none dark:text-slate-300 text-primary"
        >
          42
        </div>
        <div class="stat-desc font-bold text-green-700 dark:text-green-300">
            +1.3M this Month
          </div>
      </div>
    </div>
    <div class="stats shadow bg-white dark:bg-base-100 rounded-box">
      <div class="stat p-2 md:p-4">
        <div class="stat-figure dark:text-slate-300 text-primary hidden md:flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
            class="w-8 h-8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"
            ></path>
          </svg>
        </div>
        <div class="stat-title text-xs md:text-base dark:text-slate-300 mb-1">
          Pending
        </div>
        <div
          class="stat-value text-2xl md:text-4xl leading-none dark:text-slate-300 text-primary"
        >
          16
        </div>
        <div class="stat-desc font-bold text-green-700 dark:text-green-300">
            +528 this Month
          </div>
      </div>
    </div>
  </div> -->
</ng-container>

<qwiko-edit-business-profile
  [loading]="loading()"
></qwiko-edit-business-profile>

<!-- Manage Payment Account modal -->
<qwiko-manage-payment-accounts
  [(isListAccounts)]="isManagePaymentAccount"
  [(loading)]="loading"
  [context]="'SETTINGS'"
></qwiko-manage-payment-accounts>
